function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddFolder = function SvgAddFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.88 6.25H2.5A2.11 2.11 0 0 1 .38 4.12V2.25A2.1 2.1 0 0 1 2.5.12h2.38A2.11 2.11 0 0 1 7 2.25v2a2.27 2.27 0 0 1-2.12 2M2.5 1.37a.86.86 0 0 0-.88.88v2a.85.85 0 0 0 .88.87h2.38a.85.85 0 0 0 .87-.87v-2a.85.85 0 0 0-.87-.88Zm18.5 0H9.12A.59.59 0 0 1 8.5.75a.59.59 0 0 1 .62-.63H21a.59.59 0 0 1 .62.63.58.58 0 0 1-.62.62m0 2.38H9.12a.59.59 0 0 1-.62-.63.59.59 0 0 1 .62-.62H21a.58.58 0 0 1 .62.62.59.59 0 0 1-.62.63m-6.25 2.5H9.12a.59.59 0 0 1-.62-.63.59.59 0 0 1 .62-.62h5.63a.6.6 0 0 1 .63.62.67.67 0 0 1-.63.63m-9.87 8.62H2.5a2.08 2.08 0 0 1-2.12-2.08v-2A2.08 2.08 0 0 1 2.5 8.75h2.38A2.09 2.09 0 0 1 7 10.83v2a2.16 2.16 0 0 1-2.12 2.04M2.5 10a.85.85 0 0 0-.88.87v2a.86.86 0 0 0 .88.88h2.38a.85.85 0 0 0 .87-.88v-2a.85.85 0 0 0-.87-.87Zm18.5.25H9.12a.63.63 0 0 1 0-1.25H21a.63.63 0 0 1 0 1.25m0 2.37H9.12a.63.63 0 0 1 0-1.25H21a.63.63 0 0 1 0 1.25M14.75 15H9.12a.63.63 0 0 1 0-1.25h5.63a.6.6 0 0 1 .63.62.67.67 0 0 1-.63.63m-9.87 8.87H2.5a2.1 2.1 0 0 1-2.12-2.12v-2a2.1 2.1 0 0 1 2.12-2.13h2.38A2.11 2.11 0 0 1 7 19.75v2a2.18 2.18 0 0 1-2.12 2.12m-2.38-5a.86.86 0 0 0-.88.88v2a.85.85 0 0 0 .88.87h2.38a.85.85 0 0 0 .87-.87v-2a.85.85 0 0 0-.87-.88ZM21 19H9.12a.63.63 0 0 1 0-1.25H21A.63.63 0 0 1 21 19m0 2.5H9.12a.63.63 0 0 1 0-1.25H21a.63.63 0 0 1 0 1.25m-6.25 2.37H9.12a.63.63 0 0 1 0-1.25h5.63a.6.6 0 0 1 .63.63.67.67 0 0 1-.63.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 12,
    r: 10,
    style: {
      fill: "#06d1bd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    style: {
      isolation: "isolate",
      fontSize: 12,
      fill: "#fff",
      fontFamily: "OpenSans-Bold,Open Sans",
      fontWeight: 700
    },
    transform: "translate(19.58 16)"
  }, "+")));
};
export default SvgAddFolder;